// extracted by mini-css-extract-plugin
module.exports = {"detailsBox":"_1UkfLZl","modal":"_2vz6y56","featured":"_2q148A_","item":"_1w9mhAw","yourInfo":"_1le2ARO","gameItemTime":"_5nHKIMe","info":"_1sw8aRe","completed":"_3LAiOnG"};